<template>
  <div v-if="carregaModel" :submit="ConsultaSPC">
    <v-card>
      <v-row class="d-flex justify-center">
        <v-card-title class="text-h5 primary--text">Resultado da Consulta</v-card-title>
      </v-row>
      <v-row class="justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-btn label="teste" class="mr-3 mb-3" v-bind="attrs" v-on="on" depressed color="primary"
                @click="exportaBureauSPC" data-cy="exportarPDF">
                <v-icon>ph-file-pdf</v-icon>
              </v-btn>
          </template>
          <span>Exportar PDF</span>
        </v-tooltip>
      </v-row>
      <v-card-text>
        <span class="text-h5 ml-3 primary--text">Dados da Consulta</span>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="4" class="mt-3 mb-5" v-if="model.Data">
            <v-row class="text-subtitle font-weight-bold"> Data da consulta </v-row>
            <v-row class="text-subtitle"> {{ $api.UI.Format.DateTime(model.Data) }} </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5" v-if="model.Protocolo.ProtocoloFormatado">
            <v-row class="text-subtitle font-weight-bold"> Protocolo </v-row>
            <v-row class="text-subtitle"> {{ model.Protocolo.ProtocoloFormatado }} </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle font-weight-bold"> Possui Restrição </v-row>
            <v-row class="text-subtitle"> {{ model.Restricao ? 'SIM' : 'NÃO' }} </v-row>
          </v-col>
        </v-row>
        <SpcBrasilPF v-if="model.Consumidor.ConsumidorPessoaFisica" ref="spcBrasilPF" :model="model"></SpcBrasilPF>
        <SpcBrasilPJ v-if="model.Consumidor.ConsumidorPessoaJuridica" ref="spcBrasilPJ" :model="model"></SpcBrasilPJ>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    SpcBrasilPF: () => import('./SpcBrasilPF.vue'),
    SpcBrasilPJ: () => import('./SpcBrasilPJ.vue')
  },
  data () {
    return {
      model: {},
      carregaModel: false
    }
  },
  methods: {
    ConsultaSPC (documento) {
      const th = this

      th.model = {}
      th.carregaModel = false

      var dto = {
        consulta: {
          Documento: documento
        }
      }

      th.$api.Multiplo.Post('ConsultaSPCSemReceita', dto).then((response) => {
        if (response.HasError || response.Falha || response.error) {
          th.$emit('error')
          th.$api.UI.ShowError('Erro', response.Msg);
        } else {
          const responseFormatada = JSON.parse(response.JSON);
          th.$api.UTIL.SetAllButNull(th, 'model', responseFormatada)
          th.carregaModel = true
        }
      })
    },
    exportaBureauSPC (tipo) {
      const th = this
      var dto = {
        consulta: th.model
      }
      th.$api.Bureau.GerarPDFSPC(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.downloadBureau(response.data, tipo)
        }
      })
    },
    downloadBureau (file, tipo) {
      var documentoModel = ''
      if (this.model.Consumidor.ConsumidorPessoaFisica) {
        documentoModel = this.model.Consumidor.ConsumidorPessoaFisica.CPF.Numero
      } else {
        documentoModel = this.model.Consumidor.ConsumidorPessoaJuridica.CNPJ.Numero
      }
      var nomeArquivo = 'SPC Brasil - ' + documentoModel + '.pdf'
      var blob = tipo === 1 ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' }) : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    }
  }
}
</script>
